import React from 'react';
import styled from 'styled-components';
import ThinkfabLogo from './ThinkfabLogo';
import WeDoDevLogo from './WeDoDevLogo';

const LogoContainer = styled.div`
  align-items: baseline; /* Aligne les éléments sur leur ligne de base */
  display: inline-flex; /* Utilise inline-flex pour permettre le centrage */
  flex-direction: row; /* Force l'affichage horizontal */
  white-space: nowrap; /* Empêche le retour à la ligne */
`;

interface LogoProps {
  className?: string;
  thinkfabColor?: string;
  separatorColor?: string;
  weDoColor?: string;
  devColor?: string;
  color?: string; // Fallback color for all parts
  size?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  className, 
  thinkfabColor,
  separatorColor,
  weDoColor,
  devColor,
  color = 'inherit', 
  size = '24px' 
}) => {
  return (
    <LogoContainer className={className} style={{ fontSize: size }}>
      <ThinkfabLogo 
        thinkfabColor={thinkfabColor} 
        separatorColor={separatorColor} 
        color={color} 
        size={size} 
      />
      <div style={{ marginLeft: '4px' }}>
        <WeDoDevLogo 
          weDoColor={weDoColor} 
          devColor={devColor} 
          color={color} 
          size={size} 
        />
      </div>
    </LogoContainer>
  );
};

export default Logo;